import { DocumentInsightsEnum, DriveEventActionEnum } from '@workalizer/shared';
export var getInsightsType = function (action) {
    switch (action) {
        case DriveEventActionEnum.DOCUMENT_CREATE_COMMENT:
            return DocumentInsightsEnum.mostCommented;
        case DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION:
            return DocumentInsightsEnum.mostChangesSuggested;
        case DriveEventActionEnum.DOCUMENT_APPROVAL_REQUESTED:
            return DocumentInsightsEnum.approvalRequested;
        case DriveEventActionEnum.DOCUMENT_VIEW:
            return DocumentInsightsEnum.topViewed;
        case DriveEventActionEnum.DOCUMENT_COPY:
            return DocumentInsightsEnum.topCopied;
        case 'unresolvedComments':
            return DocumentInsightsEnum.unresolvedComments;
        case 'suggestionsPending':
            return DocumentInsightsEnum.suggestionsPending;
        case 'approvalPending':
            return DocumentInsightsEnum.approvalPending;
        case DriveEventActionEnum.DOCUMENT_EDIT:
            return DocumentInsightsEnum.topEdited;
        case DriveEventActionEnum.DOCUMENT_DOWNLOAD:
            return DocumentInsightsEnum.topDownloaded;
        default:
            return undefined;
    }
};
